import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";

import {
    getAutoavaliacaoCamposApagados,
    undeleteAutoavaliacaoCampo,
    hardDeleteAutoavaliacaoCampo,
} from "./FormularioApi";

interface IPergunta {
    id: number;
    titulo: string;
}

interface IPerguntasApagadasModalProps {
    show: boolean;
    onHide: () => void;
}

export default function PerguntasApagadasModal({
    show,
    onHide,
}: IPerguntasApagadasModalProps) {
    const [perguntas, setPerguntas] = useState<IPergunta[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show) {
            carregar();
        }
    }, [show]);

    async function carregar() {
        setLoading(true);

        try {
            const response = await getAutoavaliacaoCamposApagados();
            setPerguntas(response.data);
        } finally {
            setLoading(false);
        }
    }

    async function recuperar(id: number) {
        await undeleteAutoavaliacaoCampo(id);
        await carregar();
    }

    async function apagar(id: number) {
        if (
            !window.confirm(
                "Deseja apagar definitivamente esta pergunta?"
            )
        ) {
            return;
        }

        await hardDeleteAutoavaliacaoCampo(id);
        await carregar();
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Perguntas apagadas</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {loading ? (
                    <>Carregando...</>
                ) : perguntas.length === 0 ? (
                    <>Nenhuma pergunta apagada.</>
                ) : (
                    <Table bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Pergunta</th>
                                <th width={220}>Ações</th>
                            </tr>
                        </thead>

                        <tbody>
                            {perguntas.map((pergunta) => (
                                <tr key={pergunta.id}>
                                    <td>{pergunta.titulo}</td>

                                    <td>
                                        <div className="d-flex gap-2">
                                            <Button
                                                size="sm"
                                                variant="success"
                                                onClick={() =>
                                                    recuperar(pergunta.id)
                                                }
                                            >
                                                Recuperar
                                            </Button>

                                            <Button
                                                size="sm"
                                                variant="danger"
                                                onClick={() =>
                                                    apagar(pergunta.id)
                                                }
                                            >
                                                Apagar definitivamente
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}